import React from 'react';
import { connect } from 'react-redux';
import { Button, Dropdown, Form, Grid, Header, Icon, Modal, TextArea } from 'semantic-ui-react';
import { showSuccessAlert, hideAddCommentModal, hideCountDetailsModal, showCountDetailsModal, showViewCommentsModal, showAddCommentModal } from '../../redux/actions/modals';
import DownloadButton from '../shared/DownloadButton';
import DataGrid from '../shared/DataGrid';
import count from '../../api/count';
import { handleDownload } from '../../helpers/downloads';

class CountDetailsModal extends React.Component {

  state = { 
    activeRow: { collectionId: 0 },
    downloadLoading: false,
    loadingReport: true,
    loading: false,
  }

  componentDidUpdate(prevProps) {
    if (this.props.modal.batchId !== prevProps.modal.batchId) {
      this.handleRefresh();
    }
  }

  handleClose = () => this.props.hideCountDetailsModal();

  onViewCommentsClick = () => {
    const { batchId, collectionType } = this.props.modal;
    this.setState({ loadingComments: true }, () => {
      count.getComments(collectionType, batchId).then(
        comments => this.setState({ loadingComments: false }, () => this.props.showViewCommentsModal(comments))
      );
    })
  }

  handleSaveComment = async (comment) => {
    const { collectionId } = this.state.activeRow;
    const { collectionType } = this.props.modal;
    count.addComment(collectionType, collectionId, comment).then(
      response => {
          this.props.showSuccessAlert(response, "Success", () => this.props.hideAddCommentModal().then(() => this.handleRefresh()))
      }
    );
  }

  handleRefresh = () => {
    const { batchId, collectionType } = this.props.modal;
    this.setState({ loading: true }, () => {
      count.getBatch(batchId, collectionType).then(
        response => this.setState({ loading: false }, () => this.props.showCountDetailsModal({...response, batchId, collectionType }, this.handleRefresh)),
        () => this.setState({ loading: false })
      )
    });
  }


  handleAddComment = () => {
    const { siteDisplay, countDateDisplay } = this.props.modal;
    const { gameName } = this.state.activeRow;
    this.props.showAddCommentModal(
      `${siteDisplay} ${countDateDisplay}`, 
      gameName, 
      this.handleSaveComment,
    )
  }

  downloadReport = () => {
    const { batchId } = this.props.modal;
    this.setState({ loadingReport: true }, () => {
      count.getReportPdf(batchId).then(
        response => this.setState({ loadingReport: false }, () => handleDownload("Machine Count PDF", response)),
        () => this.setState({ loadingReport: false })
      )
    })
  }

  downloadExport = () => {
    const { batchId, collectionType } = this.props.modal;
    this.setState({ downloadLoading: true }, () => {
      count.getBatchExport(batchId, collectionType).then(
        response => this.setState({ downloadLoading: false }, () => handleDownload("Machine Count CSV", response)),
        () => this.setState({ downloadLoading: false })
      )
    })
  }

  render() {
    const { headerDef, rowDef, data } = this.props.modal;
    const { reportLoading, downloadLoading, activeRow, loading, loadingComments } = this.state;
    const { siteDisplay, countDateDisplay } = this.props.modal;

    return (
        <Modal
            open={this.props.modal.open}
            onClose={this.handleClose}
            size='fullscreen'
            className="h-60"
            closeIcon
        >
          <Modal.Header>Count Details</Modal.Header>
          <Modal.Content className="h-100">
            <Grid className="height-100 flex-container">
              <Grid.Row>
                <Grid.Column width="8">
                  <Header size="small" className="mb-0_5">
                    {siteDisplay}
                  </Header>
                  <DownloadButton onClick={this.downloadExport} loading={downloadLoading} className="mr-1" />
                    Count Date: {countDateDisplay}
                </Grid.Column>
                <Grid.Column width="8" textAlign='right'>
                  <Button content='Add Comment' color='teal' onClick={this.handleAddComment} disabled={!activeRow || activeRow.collectionId < 1} />
                  <Button content='View Comments' color='teal' onClick={this.onViewCommentsClick} loading={loadingComments} />
                  <Dropdown
                    direction="left"
                    icon={null}
                    trigger={<Button color="teal" loading={reportLoading} icon labelPosition="right"><Icon name="caret down" /> Reports</Button>}
                  >
                    <Dropdown.Menu>
                      <Dropdown.Item text="Machine Count" onClick={this.downloadReport} />
                    </Dropdown.Menu>
                  </Dropdown>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row className="flex-stretch">
                <Grid.Column width="16" className='gs-flex-container-vertical'>
                  <DataGrid
                    headings={headerDef}
                    data={data}
                    fullHeight
                    rowDef={rowDef}
                    onRowClick={activeRow => this.setState({ activeRow }, () => console.log(activeRow))}
                    loading={loading}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Modal.Content>
        </Modal>
    )
  }
}

const mapStateToProps = state => {
	return {
    modal: state.countDetailsModal,
  };
};

export default connect(mapStateToProps, { showSuccessAlert, hideAddCommentModal, showAddCommentModal, showCountDetailsModal, hideCountDetailsModal, showViewCommentsModal })(CountDetailsModal);